import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import {  observable, Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import {ToastrService} from 'ngx-toastr';

const AUTH_API = environment.apiURL;

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  isLogin = false;
    
  roleAs: any;
  userName: any;
  vehicleState:any;

  constructor(private http: HttpClient,  private toastr: ToastrService) { }

  login(data:any): Observable<any> {
     return this.http.post<{token: string}>(AUTH_API+"/users/signin", data)
      .pipe(
        map(result => {
          localStorage.setItem('access_token', result.token);
          this.isLogin = true;
         // console.log(result.token)
          return result;
        }),
        catchError(this.errorHandler)
      );
    //return this.http.get('http://e1e9-112-196-159-174.ngrok.io/fsw/getParameters/25')
  }

  // public get loggedIn(): boolean {
  //   return (localStorage.getItem('access_token') !== null);
  // }

  getUserDetails(userId:String): Observable<any> {
    
    return this.http.get<any>(AUTH_API + '/users/getUserDetails/'+userId)
    .pipe(
     
      catchError(this.errorHandler)
      //this.toastr.error('errorMessage');
      
  
    );
  }

  errorHandler(error:any) {
    
    let errorMessage = '';
    if(error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
    
 }

 logout() {
  this.isLogin = false;
  this.roleAs = '';
  localStorage.removeItem('access_token');
  localStorage.setItem('STATE', 'false');
  localStorage.setItem('ROLE', '');
  return of({ success: this.isLogin, role: '' });
}

isLoggedIn() {
  const loggedIn = localStorage.getItem('STATE');
  if (loggedIn == 'true')
    this.isLogin = true;
  else
    this.isLogin = false;
  return this.isLogin;
}

getRole() {
  this.roleAs = localStorage.getItem('ROLE');
  return this.roleAs;
}

getUserName() {
  this.userName = localStorage.getItem('USER_NAME');
  return this.userName;
}
getState() {
    return localStorage.getItem('STATE');
}

verifyOtp(data:any): Observable<any> {
 
  return this.http.post<{token: string}>(AUTH_API+"/users/validateOtp", data)
      .pipe( );
}

setPassword(data:any): Observable<any> {
 
  return this.http.post<{token: string}>(AUTH_API+"/users/setPassword", data)
      .pipe( );
}

getToken() {
  return localStorage.getItem('access_token');
}

setVehicleState(stateCode:any){
  this.vehicleState = stateCode;

}

getVehicleState(){
  return this.vehicleState;

}

  
}
